// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  CreateBorLetterEndpointBorCreatePostData,
  CreateBorLetterEndpointBorCreatePostResponse,
  GetBorLetterEndpointBorGetPostData,
  GetBorLetterEndpointBorGetPostResponse,
  GetBorLettersByReportEndpointBorByReportPostData,
  GetBorLettersByReportEndpointBorByReportPostResponse,
  ListBorLettersEndpointBorListPostData,
  ListBorLettersEndpointBorListPostResponse,
  MarkBorStepEndpointBorMarkStepPostData,
  MarkBorStepEndpointBorMarkStepPostResponse,
  CheckBorDeadlinesEndpointBorCheckDeadlinesPostResponse,
  ListContactsEndpointCrmContactsGetResponse,
  CreateContactEndpointCrmContactPostData,
  CreateContactEndpointCrmContactPostResponse,
  UpdateContactEndpointCrmContactContactIdPostData,
  UpdateContactEndpointCrmContactContactIdPostResponse,
  BrokerAnalyticsCrmBrokerAnalyticsGetData,
  BrokerAnalyticsCrmBrokerAnalyticsGetResponse,
  CrmBrokerExportCrmBrokerExportPostResponse,
  GetSubmissionStatusCountsCrmSubmissionStatusCountsGetResponse,
  GetPolicyflyApplicationsCrmPolicyflyApplicationsGetData,
  GetPolicyflyApplicationsCrmPolicyflyApplicationsGetResponse,
  AsgardListReportActionLogsAsgardListReportActionLogsPostData,
  AsgardListReportActionLogsAsgardListReportActionLogsPostResponse,
  AsgardGetReportActionLogAsgardGetReportActionLogPostData,
  AsgardGetReportActionLogAsgardGetReportActionLogPostResponse,
  InitiateRequestEndpointIcmInitiatePostData,
  InitiateRequestEndpointIcmInitiatePostResponse,
  InitiateTestRequestEndpointIcmInitiateTestPostData,
  InitiateTestRequestEndpointIcmInitiateTestPostResponse,
  RequestStatusIcmStatusRequestIdGetData,
  RequestStatusIcmStatusRequestIdGetResponse,
  InitiateRmsRequestRmsInitiatePostData,
  InitiateRmsRequestRmsInitiatePostResponse,
  RmsRequestStatusRmsStatusRequestIdGetData,
  RmsRequestStatusRmsStatusRequestIdGetResponse,
  InitiateSpatialkatRequestSpatialkatInitiatePostData,
  InitiateSpatialkatRequestSpatialkatInitiatePostResponse,
  SpatialkatRequestStatusSpatialkatStatusRequestIdGetData,
  SpatialkatRequestStatusSpatialkatStatusRequestIdGetResponse,
  InitiateRmsEltRequestRmsEltInitiatePostData,
  InitiateRmsEltRequestRmsEltInitiatePostResponse,
  RmsEltRequestStatusRmsEltStatusRequestIdGetData,
  RmsEltRequestStatusRmsEltStatusRequestIdGetResponse,
  InitiateIcmYltRequestIcmYltInitiatePostData,
  InitiateIcmYltRequestIcmYltInitiatePostResponse,
  IcmYltRequestStatusIcmYltStatusRequestIdGetData,
  IcmYltRequestStatusIcmYltStatusRequestIdGetResponse,
  CatPrecheckCatPrecheckReportIdGetData,
  CatPrecheckCatPrecheckReportIdGetResponse,
  DownloadCatArtifactCatDownloadReportIdBatchIdGetData,
  DownloadCatArtifactCatDownloadReportIdBatchIdGetResponse,
  DownloadAllCatArtifactsZipCatDownloadAllReportIdBatchIdGetData,
  DownloadAllCatArtifactsZipCatDownloadAllReportIdBatchIdGetResponse,
  GetCatJobHistoryCatJobHistoryReportIdGetData,
  GetCatJobHistoryCatJobHistoryReportIdGetResponse,
  GetCatResultsCatResultsReportIdGetData,
  GetCatResultsCatResultsReportIdGetResponse,
  ResumeCatPipelineCatReportIdResumePostData,
  ResumeCatPipelineCatReportIdResumePostResponse,
  RerunCatFinancialCatReportIdRerunFinancialPostData,
  RerunCatFinancialCatReportIdRerunFinancialPostResponse,
  GetDeductibleSummaryDeductibleSummaryPostData,
  GetDeductibleSummaryDeductibleSummaryPostResponse,
  AsgardIngestEmailAsgardIngestEmailPostData,
  AsgardIngestEmailAsgardIngestEmailPostResponse,
  GetIntegrationDataIntegrationDataPostData,
  GetIntegrationDataIntegrationDataPostResponse,
  GetLimitSummaryLimitSummaryPostData,
  GetLimitSummaryLimitSummaryPostResponse,
  InitiateNearmapRequestNearmapInitiatePostData,
  InitiateNearmapRequestNearmapInitiatePostResponse,
  NearmapRequestStatusNearmapStatusRequestIdGetData,
  NearmapRequestStatusNearmapStatusRequestIdGetResponse,
  GetNearmapJobHistoryNearmapJobHistoryReportIdGetData,
  GetNearmapJobHistoryNearmapJobHistoryReportIdGetResponse,
  CalculatePremiumAsgardPremiumCalculatedPostData,
  CalculatePremiumAsgardPremiumCalculatedPostResponse,
  GetResolvedPremiumsAsgardPremiumResolvedPostData,
  GetResolvedPremiumsAsgardPremiumResolvedPostResponse,
  ReconcilePolicyflyAsgardReconcilePolicyflyPostResponse,
  AsgardRatePrecheckAsgardRatePrecheckReportIdGetData,
  AsgardRatePrecheckAsgardRatePrecheckReportIdGetResponse,
  AsgardRateSubmissionAsgardRateSubmissionPostData,
  AsgardRateSubmissionAsgardRateSubmissionPostResponse,
  DownloadRaterWorkbookRaterDownloadReportIdBatchIdGetData,
  DownloadRaterWorkbookRaterDownloadReportIdBatchIdGetResponse,
  GetRateComponentsRaterRateComponentsReportIdBatchIdGetData,
  GetRateComponentsRaterRateComponentsReportIdBatchIdGetResponse,
  GetBookSummaryAsgardReinsurerViewBookSummaryGetData,
  GetBookSummaryAsgardReinsurerViewBookSummaryGetResponse,
  GetSubmissionAnalyticsAsgardSubmissionAnalyticsGetResponse,
  GetLocationClassificationsLocationClassificationsPostData,
  GetLocationClassificationsLocationClassificationsPostResponse,
  HealthcheckHealthcheckGetResponse,
  LoginLoginPostData,
  LoginLoginPostResponse,
  ListUsersListUsersPostResponse,
  LogEventLogEventPostData,
  LogEventLogEventPostResponse,
  AsgardListReportsPostAsgardListReportsPostData,
  AsgardListReportsPostAsgardListReportsPostResponse,
  AsgardListReportAsgardListReportReportIdGetData,
  AsgardListReportAsgardListReportReportIdGetResponse,
  AsgardGoogleGroupStatsAsgardGoogleGroupStatsPostData,
  AsgardGoogleGroupStatsAsgardGoogleGroupStatsPostResponse,
  AsgardEmailThreadsAsgardEmailThreadsReportIdGetData,
  AsgardEmailThreadsAsgardEmailThreadsReportIdGetResponse,
  AsgardDeleteEmailThreadAsgardDeleteEmailThreadReportIdPostData,
  AsgardDeleteEmailThreadAsgardDeleteEmailThreadReportIdPostResponse,
  AsgardDownloadThreadAttachmentAsgardDownloadThreadAttachmentPostData,
  AsgardDownloadThreadAttachmentAsgardDownloadThreadAttachmentPostResponse,
  AsgardGenerateUnderwritingPdfAsgardGenerateUnderwritingPdfPostData,
  AsgardGenerateUnderwritingPdfAsgardGenerateUnderwritingPdfPostResponse,
  AsgardQuoteIndicationPreflightAsgardQuoteIndicationPreflightPostData,
  AsgardQuoteIndicationPreflightAsgardQuoteIndicationPreflightPostResponse,
  AsgardGenerateQuoteIndicationDraftAsgardGenerateQuoteIndicationDraftPostData,
  AsgardGenerateQuoteIndicationDraftAsgardGenerateQuoteIndicationDraftPostResponse,
  AsgardDownloadLossRunAsgardDownloadLossRunPostData,
  AsgardDownloadLossRunAsgardDownloadLossRunPostResponse,
  AsgardUpdateReportAsgardUpdateReportPostData,
  AsgardUpdateReportAsgardUpdateReportPostResponse,
  AsgardAddManualAddressAsgardAddManualAddressPostData,
  AsgardAddManualAddressAsgardAddManualAddressPostResponse,
  AsgardBatchCommentsAsgardCommentsPostData,
  AsgardBatchCommentsAsgardCommentsPostResponse,
  AsgardAddCommentAsgardAddCommentPostData,
  AsgardAddCommentAsgardAddCommentPostResponse,
  AsgardDeleteCommentAsgardDeleteCommentPostData,
  AsgardDeleteCommentAsgardDeleteCommentPostResponse,
  AsgardEditCommentAsgardEditCommentPostData,
  AsgardEditCommentAsgardEditCommentPostResponse,
  AsgardDeleteReportAsgardDeleteReportPostData,
  AsgardDeleteReportAsgardDeleteReportPostResponse,
  AsgardUpdateAddressAsgardUpdateAddressPostData,
  AsgardUpdateAddressAsgardUpdateAddressPostResponse,
  AsgardListAdditionalFilesAsgardListAdditionalFilesReportIdPostData,
  AsgardListAdditionalFilesAsgardListAdditionalFilesReportIdPostResponse,
  AsgardDeleteAdditionalFilesAsgardDeleteAdditionalFilesReportIdPostData,
  AsgardDeleteAdditionalFilesAsgardDeleteAdditionalFilesReportIdPostResponse,
  AsgardDeleteAttachmentAsgardDeleteAttachmentPostData,
  AsgardDeleteAttachmentAsgardDeleteAttachmentPostResponse,
  AsgardTestPythonFunctionAsgardTestPythonFunctionReportIdPostData,
  AsgardTestPythonFunctionAsgardTestPythonFunctionReportIdPostResponse,
  AsgardUploadAdditionalFileAsgardUploadAdditionalFilesPostData,
  AsgardUploadAdditionalFileAsgardUploadAdditionalFilesPostResponse,
  AsgardUploadEmlsAsgardUploadEmlsPostData,
  AsgardUploadEmlsAsgardUploadEmlsPostResponse,
  AsgardUploadEmailThreadAsgardUploadEmailThreadPostData,
  AsgardUploadEmailThreadAsgardUploadEmailThreadPostResponse,
  AsgardDownloadAdditionalFileAsgardDownloadAdditionalFilePostData,
  AsgardDownloadAdditionalFileAsgardDownloadAdditionalFilePostResponse,
  GenerateBulkEditAsgardGenerateBulkEditPostData,
  GenerateBulkEditAsgardGenerateBulkEditPostResponse,
  DownloadReportFileAsgardDownloadReportFilePostData,
  DownloadReportFileAsgardDownloadReportFilePostResponse,
  DevDumpCoroutinesDevDumpCoroutinesPostResponse,
  CspReportCspReportPostResponse,
  AsgardListSavedFiltersAsgardListSavedFiltersPostResponse,
  AsgardDeleteSavedFilterAsgardDeleteSavedFilterPostData,
  AsgardDeleteSavedFilterAsgardDeleteSavedFilterPostResponse,
  AsgardUpdateSavedFilterAsgardUpdateSavedFilterPostData,
  AsgardUpdateSavedFilterAsgardUpdateSavedFilterPostResponse,
  AsgardAddSavedFilterAsgardAddSavedFilterPostData,
  AsgardAddSavedFilterAsgardAddSavedFilterPostResponse,
  AsgardLoadAddressesForMapAsgardLoadAddressesForMapPostData,
  AsgardLoadAddressesForMapAsgardLoadAddressesForMapPostResponse,
  AsgardLoadAddressesAsgardLoadAddressesReportIdSovIdGetData,
  AsgardLoadAddressesAsgardLoadAddressesReportIdSovIdGetResponse,
  AsgardEmlPreviewAsgardEmlPreviewPostData,
  AsgardEmlPreviewAsgardEmlPreviewPostResponse,
  AsgardDownloadReportHistoryAsgardDownloadReportHistoryPostData,
  AsgardDownloadReportHistoryAsgardDownloadReportHistoryPostResponse,
  AsgardListUpdatingReportsAsgardListUpdatingReportsPostData,
  AsgardListUpdatingReportsAsgardListUpdatingReportsPostResponse,
  AsgardListReportJobsAsgardListReportJobsPostData,
  AsgardListReportJobsAsgardListReportJobsPostResponse,
  AsgardCancelJobAsgardCancelJobPostData,
  AsgardCancelJobAsgardCancelJobPostResponse,
  AsgardListTemplatesAsgardListTemplatesPostResponse,
  AsgardDeleteTemplateAsgardDeleteTemplatePostData,
  AsgardDeleteTemplateAsgardDeleteTemplatePostResponse,
  AsgardUpdateTemplateAsgardUpdateTemplatePostData,
  AsgardUpdateTemplateAsgardUpdateTemplatePostResponse,
  AsgardCreateTemplateAsgardCreateTemplatePostData,
  AsgardCreateTemplateAsgardCreateTemplatePostResponse,
  AsgardDownloadTemplateAsgardDownloadTemplatePostData,
  AsgardDownloadTemplateAsgardDownloadTemplatePostResponse,
  AsgardGeneratePolicyNumbersAsgardGeneratePolicyNumbersPostData,
  AsgardGeneratePolicyNumbersAsgardGeneratePolicyNumbersPostResponse,
  AsgardGeneratePolicyFlyApplicationAsgardGeneratePolicyFlyApplicationPostData,
  AsgardGeneratePolicyFlyApplicationAsgardGeneratePolicyFlyApplicationPostResponse,
  AsgardClearanceEmailRecipientsAsgardClearanceEmailRecipientsPostData,
  AsgardClearanceEmailRecipientsAsgardClearanceEmailRecipientsPostResponse,
  AsgardSendClearanceEmailAsgardSendClearanceEmailPostData,
  AsgardSendClearanceEmailAsgardSendClearanceEmailPostResponse,
  SyncMetabaseAsgardSyncMetabasePostResponse,
} from "./types.gen";

/**
 * Create Bor Letter Endpoint
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BorLetterResponse Successful Response
 * @throws ApiError
 */
export const createBorLetterEndpointBorCreatePost = (
  data: CreateBorLetterEndpointBorCreatePostData
): CancelablePromise<CreateBorLetterEndpointBorCreatePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/bor/create",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Bor Letter Endpoint
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BorLetterResponse Successful Response
 * @throws ApiError
 */
export const getBorLetterEndpointBorGetPost = (
  data: GetBorLetterEndpointBorGetPostData
): CancelablePromise<GetBorLetterEndpointBorGetPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/bor/get",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Bor Letters By Report Endpoint
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BorLetterListResponse Successful Response
 * @throws ApiError
 */
export const getBorLettersByReportEndpointBorByReportPost = (
  data: GetBorLettersByReportEndpointBorByReportPostData
): CancelablePromise<GetBorLettersByReportEndpointBorByReportPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/bor/by_report",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * List Bor Letters Endpoint
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BorLetterListResponse Successful Response
 * @throws ApiError
 */
export const listBorLettersEndpointBorListPost = (
  data: ListBorLettersEndpointBorListPostData
): CancelablePromise<ListBorLettersEndpointBorListPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/bor/list",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Mark Bor Step Endpoint
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BorLetterResponse Successful Response
 * @throws ApiError
 */
export const markBorStepEndpointBorMarkStepPost = (
  data: MarkBorStepEndpointBorMarkStepPostData
): CancelablePromise<MarkBorStepEndpointBorMarkStepPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/bor/mark_step",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Check Bor Deadlines Endpoint
 * Cron-callable endpoint (run hourly).  Scans active BOR letters,
 * finds newly-triggered tiered alerts, posts them to #bor-requests,
 * and marks them as sent so they won't fire again on the next run.
 * @returns CheckBorDeadlinesResponse Successful Response
 * @throws ApiError
 */
export const checkBorDeadlinesEndpointBorCheckDeadlinesPost =
  (): CancelablePromise<CheckBorDeadlinesEndpointBorCheckDeadlinesPostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/bor/check_deadlines",
    });
  };

/**
 * List Contacts Endpoint
 * List all contacts for the current user's client.
 * @returns ListContactsResponse Successful Response
 * @throws ApiError
 */
export const listContactsEndpointCrmContactsGet =
  (): CancelablePromise<ListContactsEndpointCrmContactsGetResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/crm/contacts",
    });
  };

/**
 * Create Contact Endpoint
 * Create a new contact.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CreateContactResponse Successful Response
 * @throws ApiError
 */
export const createContactEndpointCrmContactPost = (
  data: CreateContactEndpointCrmContactPostData
): CancelablePromise<CreateContactEndpointCrmContactPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/crm/contact",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Update Contact Endpoint
 * Update a contact's information.
 * @param data The data for the request.
 * @param data.contactId
 * @param data.requestBody
 * @returns UpdateContactResponse Successful Response
 * @throws ApiError
 */
export const updateContactEndpointCrmContactContactIdPost = (
  data: UpdateContactEndpointCrmContactContactIdPostData
): CancelablePromise<UpdateContactEndpointCrmContactContactIdPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/crm/contact/{contact_id}",
    path: {
      contact_id: data.contactId,
    },
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Broker Analytics
 * Returns a variety of broker-related analytics based on the selected date range and report type.
 * @param data The data for the request.
 * @param data.dateChoice
 * @param data.reportSelection
 * @returns GetBrokerAnalyticsResponse Successful Response
 * @throws ApiError
 */
export const brokerAnalyticsCrmBrokerAnalyticsGet = (
  data: BrokerAnalyticsCrmBrokerAnalyticsGetData
): CancelablePromise<BrokerAnalyticsCrmBrokerAnalyticsGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/crm/broker_analytics",
    query: {
      date_choice: data.dateChoice,
      report_selection: data.reportSelection,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Crm Broker Export
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const crmBrokerExportCrmBrokerExportPost =
  (): CancelablePromise<CrmBrokerExportCrmBrokerExportPostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/crm/broker_export",
    });
  };

/**
 * Get Submission Status Counts
 * @returns SubmissionStatusCountsResponse Successful Response
 * @throws ApiError
 */
export const getSubmissionStatusCountsCrmSubmissionStatusCountsGet =
  (): CancelablePromise<GetSubmissionStatusCountsCrmSubmissionStatusCountsGetResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/crm/submission_status_counts",
    });
  };

/**
 * Get Policyfly Applications
 * @param data The data for the request.
 * @param data.statuses
 * @returns ListPolicyFlyApplicationsResponse Successful Response
 * @throws ApiError
 */
export const getPolicyflyApplicationsCrmPolicyflyApplicationsGet = (
  data: GetPolicyflyApplicationsCrmPolicyflyApplicationsGetData
): CancelablePromise<GetPolicyflyApplicationsCrmPolicyflyApplicationsGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/crm/policyfly_applications",
    query: {
      statuses: data.statuses,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Report Action Logs
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListReportActionLogsResponse Successful Response
 * @throws ApiError
 */
export const asgardListReportActionLogsAsgardListReportActionLogsPost = (
  data: AsgardListReportActionLogsAsgardListReportActionLogsPostData
): CancelablePromise<AsgardListReportActionLogsAsgardListReportActionLogsPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/list_report_action_logs",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Get Report Action Log
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GetReportActionLogResponse Successful Response
 * @throws ApiError
 */
export const asgardGetReportActionLogAsgardGetReportActionLogPost = (
  data: AsgardGetReportActionLogAsgardGetReportActionLogPostData
): CancelablePromise<AsgardGetReportActionLogAsgardGetReportActionLogPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/get_report_action_log",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Initiate Request Endpoint
 * Initate an ICM request and begin the process for tracking the status of the job
 * @param data The data for the request.
 * @param data.requestBody
 * @returns InitiateResponse Successful Response
 * @throws ApiError
 */
export const initiateRequestEndpointIcmInitiatePost = (
  data: InitiateRequestEndpointIcmInitiatePostData
): CancelablePromise<InitiateRequestEndpointIcmInitiatePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/icm/initiate",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Initiate Test Request Endpoint
 * @param data The data for the request.
 * @param data.requestBody
 * @returns InitiateResponse Successful Response
 * @throws ApiError
 */
export const initiateTestRequestEndpointIcmInitiateTestPost = (
  data: InitiateTestRequestEndpointIcmInitiateTestPostData
): CancelablePromise<InitiateTestRequestEndpointIcmInitiateTestPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/icm/initiate_test",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Request Status
 * @param data The data for the request.
 * @param data.requestId
 * @returns StatusResponse Successful Response
 * @throws ApiError
 */
export const requestStatusIcmStatusRequestIdGet = (
  data: RequestStatusIcmStatusRequestIdGetData
): CancelablePromise<RequestStatusIcmStatusRequestIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/icm/status/{request_id}",
    path: {
      request_id: data.requestId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Initiate Rms Request
 * @param data The data for the request.
 * @param data.requestBody
 * @returns RmsInitiateResponse Successful Response
 * @throws ApiError
 */
export const initiateRmsRequestRmsInitiatePost = (
  data: InitiateRmsRequestRmsInitiatePostData
): CancelablePromise<InitiateRmsRequestRmsInitiatePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/rms/initiate",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Rms Request Status
 * @param data The data for the request.
 * @param data.requestId
 * @returns IntegrationStatusResult Successful Response
 * @throws ApiError
 */
export const rmsRequestStatusRmsStatusRequestIdGet = (
  data: RmsRequestStatusRmsStatusRequestIdGetData
): CancelablePromise<RmsRequestStatusRmsStatusRequestIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/rms/status/{request_id}",
    path: {
      request_id: data.requestId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Initiate Spatialkat Request
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SpatialKatInitiateResponse Successful Response
 * @throws ApiError
 */
export const initiateSpatialkatRequestSpatialkatInitiatePost = (
  data: InitiateSpatialkatRequestSpatialkatInitiatePostData
): CancelablePromise<InitiateSpatialkatRequestSpatialkatInitiatePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/spatialkat/initiate",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Spatialkat Request Status
 * @param data The data for the request.
 * @param data.requestId
 * @returns IntegrationStatusResult Successful Response
 * @throws ApiError
 */
export const spatialkatRequestStatusSpatialkatStatusRequestIdGet = (
  data: SpatialkatRequestStatusSpatialkatStatusRequestIdGetData
): CancelablePromise<SpatialkatRequestStatusSpatialkatStatusRequestIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/spatialkat/status/{request_id}",
    path: {
      request_id: data.requestId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Initiate Rms Elt Request
 * @param data The data for the request.
 * @param data.requestBody
 * @returns RmsEltInitiateResponse Successful Response
 * @throws ApiError
 */
export const initiateRmsEltRequestRmsEltInitiatePost = (
  data: InitiateRmsEltRequestRmsEltInitiatePostData
): CancelablePromise<InitiateRmsEltRequestRmsEltInitiatePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/rms-elt/initiate",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Rms Elt Request Status
 * @param data The data for the request.
 * @param data.requestId
 * @param data.version
 * @returns IntegrationStatusResult Successful Response
 * @throws ApiError
 */
export const rmsEltRequestStatusRmsEltStatusRequestIdGet = (
  data: RmsEltRequestStatusRmsEltStatusRequestIdGetData
): CancelablePromise<RmsEltRequestStatusRmsEltStatusRequestIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/rms-elt/status/{request_id}",
    path: {
      request_id: data.requestId,
    },
    query: {
      version: data.version,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Initiate Icm Ylt Request
 * @param data The data for the request.
 * @param data.requestBody
 * @returns IcmYltInitiateResponse Successful Response
 * @throws ApiError
 */
export const initiateIcmYltRequestIcmYltInitiatePost = (
  data: InitiateIcmYltRequestIcmYltInitiatePostData
): CancelablePromise<InitiateIcmYltRequestIcmYltInitiatePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/icm-ylt/initiate",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Icm Ylt Request Status
 * @param data The data for the request.
 * @param data.requestId
 * @returns IntegrationStatusResult Successful Response
 * @throws ApiError
 */
export const icmYltRequestStatusIcmYltStatusRequestIdGet = (
  data: IcmYltRequestStatusIcmYltStatusRequestIdGetData
): CancelablePromise<IcmYltRequestStatusIcmYltStatusRequestIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/icm-ylt/status/{request_id}",
    path: {
      request_id: data.requestId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Cat Precheck
 * @param data The data for the request.
 * @param data.reportId
 * @returns CatPrecheckResponse Successful Response
 * @throws ApiError
 */
export const catPrecheckCatPrecheckReportIdGet = (
  data: CatPrecheckCatPrecheckReportIdGetData
): CancelablePromise<CatPrecheckCatPrecheckReportIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/cat/precheck/{report_id}",
    path: {
      report_id: data.reportId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Download Cat Artifact
 * @param data The data for the request.
 * @param data.reportId
 * @param data.batchId
 * @param data.type Integration type: icm or rms
 * @param data.artifact Artifact prefix to download
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadCatArtifactCatDownloadReportIdBatchIdGet = (
  data: DownloadCatArtifactCatDownloadReportIdBatchIdGetData
): CancelablePromise<DownloadCatArtifactCatDownloadReportIdBatchIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/cat/download/{report_id}/{batch_id}",
    path: {
      report_id: data.reportId,
      batch_id: data.batchId,
    },
    query: {
      type: data.type,
      artifact: data.artifact,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Download All Cat Artifacts Zip
 * @param data The data for the request.
 * @param data.reportId
 * @param data.batchId
 * @param data.type Integration type: icm or rms
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadAllCatArtifactsZipCatDownloadAllReportIdBatchIdGet = (
  data: DownloadAllCatArtifactsZipCatDownloadAllReportIdBatchIdGetData
): CancelablePromise<DownloadAllCatArtifactsZipCatDownloadAllReportIdBatchIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/cat/download_all/{report_id}/{batch_id}",
    path: {
      report_id: data.reportId,
      batch_id: data.batchId,
    },
    query: {
      type: data.type,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Cat Job History
 * @param data The data for the request.
 * @param data.reportId
 * @param data.type Integration type: icm or rms.
 * @returns CatJobHistoryResponse Successful Response
 * @throws ApiError
 */
export const getCatJobHistoryCatJobHistoryReportIdGet = (
  data: GetCatJobHistoryCatJobHistoryReportIdGetData
): CancelablePromise<GetCatJobHistoryCatJobHistoryReportIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/cat/job_history/{report_id}",
    path: {
      report_id: data.reportId,
    },
    query: {
      type: data.type,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Cat Results
 * @param data The data for the request.
 * @param data.reportId
 * @param data.batchId
 * @returns CatResultsResponse Successful Response
 * @throws ApiError
 */
export const getCatResultsCatResultsReportIdGet = (
  data: GetCatResultsCatResultsReportIdGetData
): CancelablePromise<GetCatResultsCatResultsReportIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/cat/results/{report_id}",
    path: {
      report_id: data.reportId,
    },
    query: {
      batch_id: data.batchId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Resume Cat Pipeline
 * Resume ``batch_id`` (the run the user picked) from where it stalled.
 * See rms_pipeline.md ("In-place resume"). The ``type`` parameter is
 * restricted to pipeline cat types so FastAPI rejects unsupported
 * types (422) before this handler runs. RMS_ELT / RMS_22 route through
 * the per-peril resume; ICM_YLT routes through the per-chunk resume —
 * same in-place semantics either way. ``mode`` applies to ICM_YLT only:
 * ``"resume"`` keeps each failed chunk's ICM status URL (continue
 * polling); ``"restart"`` drops it so re-dispatched chunks submit fresh
 * ICM ratings — for runs stuck on a status URL that never resolves.
 * @param data The data for the request.
 * @param data.reportId
 * @param data.type
 * @param data.batchId
 * @param data.mode
 * @returns CatResumeResult Successful Response
 * @throws ApiError
 */
export const resumeCatPipelineCatReportIdResumePost = (
  data: ResumeCatPipelineCatReportIdResumePostData
): CancelablePromise<ResumeCatPipelineCatReportIdResumePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/cat/{report_id}/resume",
    path: {
      report_id: data.reportId,
    },
    query: {
      type: data.type,
      batch_id: data.batchId,
      mode: data.mode,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Rerun Cat Financial
 * Re-run only the financial stage for ``batch_id`` (the run the user
 * picked), reusing its cached model artifacts. See rms_pipeline.md
 * ("New-batch financial re-run"). The ``type`` parameter is restricted
 * to pipeline cat types so FastAPI rejects unsupported types (422)
 * before this handler runs. RMS_ELT / RMS_22 reuse per-peril ELT
 * artifacts; ICM_YLT reuses per-chunk YLT artifacts — both create a
 * new batch with one collator task that reads from the source batch.
 * @param data The data for the request.
 * @param data.reportId
 * @param data.type
 * @param data.batchId
 * @returns CatRerunFinancialResult Successful Response
 * @throws ApiError
 */
export const rerunCatFinancialCatReportIdRerunFinancialPost = (
  data: RerunCatFinancialCatReportIdRerunFinancialPostData
): CancelablePromise<RerunCatFinancialCatReportIdRerunFinancialPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/cat/{report_id}/rerun-financial",
    path: {
      report_id: data.reportId,
    },
    query: {
      type: data.type,
      batch_id: data.batchId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Deductible Summary
 * @param data The data for the request.
 * @param data.requestBody
 * @returns DeductibleSummaryResponse Successful Response
 * @throws ApiError
 */
export const getDeductibleSummaryDeductibleSummaryPost = (
  data: GetDeductibleSummaryDeductibleSummaryPostData
): CancelablePromise<GetDeductibleSummaryDeductibleSummaryPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/deductible_summary",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Ingest Email
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardIngestEmailAsgardIngestEmailPost = (
  data: AsgardIngestEmailAsgardIngestEmailPostData
): CancelablePromise<AsgardIngestEmailAsgardIngestEmailPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/ingest_email",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Integration Data
 * @param data The data for the request.
 * @param data.requestBody
 * @returns IntegrationDataResponse Successful Response
 * @throws ApiError
 */
export const getIntegrationDataIntegrationDataPost = (
  data: GetIntegrationDataIntegrationDataPostData
): CancelablePromise<GetIntegrationDataIntegrationDataPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/integration_data",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Limit Summary
 * @param data The data for the request.
 * @param data.requestBody
 * @returns LimitSummaryResponse Successful Response
 * @throws ApiError
 */
export const getLimitSummaryLimitSummaryPost = (
  data: GetLimitSummaryLimitSummaryPostData
): CancelablePromise<GetLimitSummaryLimitSummaryPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/limit_summary",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Initiate Nearmap Request
 * @param data The data for the request.
 * @param data.requestBody
 * @returns NearmapInitiateResponse Successful Response
 * @throws ApiError
 */
export const initiateNearmapRequestNearmapInitiatePost = (
  data: InitiateNearmapRequestNearmapInitiatePostData
): CancelablePromise<InitiateNearmapRequestNearmapInitiatePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/nearmap/initiate",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Nearmap Request Status
 * @param data The data for the request.
 * @param data.requestId
 * @returns IntegrationStatusResult Successful Response
 * @throws ApiError
 */
export const nearmapRequestStatusNearmapStatusRequestIdGet = (
  data: NearmapRequestStatusNearmapStatusRequestIdGetData
): CancelablePromise<NearmapRequestStatusNearmapStatusRequestIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/nearmap/status/{request_id}",
    path: {
      request_id: data.requestId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Nearmap Job History
 * @param data The data for the request.
 * @param data.reportId
 * @returns NearmapJobHistoryResponse Successful Response
 * @throws ApiError
 */
export const getNearmapJobHistoryNearmapJobHistoryReportIdGet = (
  data: GetNearmapJobHistoryNearmapJobHistoryReportIdGetData
): CancelablePromise<GetNearmapJobHistoryNearmapJobHistoryReportIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/nearmap/job_history/{report_id}",
    path: {
      report_id: data.reportId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Calculate Premium
 * Compute suggested premiums for all layers in a report.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CalculatedPremiumResponse Successful Response
 * @throws ApiError
 */
export const calculatePremiumAsgardPremiumCalculatedPost = (
  data: CalculatePremiumAsgardPremiumCalculatedPostData
): CancelablePromise<CalculatePremiumAsgardPremiumCalculatedPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/premium/calculated",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Resolved Premiums
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ResolvedPremiumsResponse Successful Response
 * @throws ApiError
 */
export const getResolvedPremiumsAsgardPremiumResolvedPost = (
  data: GetResolvedPremiumsAsgardPremiumResolvedPostData
): CancelablePromise<GetResolvedPremiumsAsgardPremiumResolvedPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/premium/resolved",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Reconcile Policyfly
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const reconcilePolicyflyAsgardReconcilePolicyflyPost =
  (): CancelablePromise<ReconcilePolicyflyAsgardReconcilePolicyflyPostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/asgard/reconcile_policyfly",
    });
  };

/**
 * Asgard Rate Precheck
 * @param data The data for the request.
 * @param data.reportId
 * @returns RatePrecheckResponse Successful Response
 * @throws ApiError
 */
export const asgardRatePrecheckAsgardRatePrecheckReportIdGet = (
  data: AsgardRatePrecheckAsgardRatePrecheckReportIdGetData
): CancelablePromise<AsgardRatePrecheckAsgardRatePrecheckReportIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/asgard/rate/precheck/{report_id}",
    path: {
      report_id: data.reportId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Rate Submission
 * @param data The data for the request.
 * @param data.requestBody
 * @returns RateSubmissionResponse Successful Response
 * @throws ApiError
 */
export const asgardRateSubmissionAsgardRateSubmissionPost = (
  data: AsgardRateSubmissionAsgardRateSubmissionPostData
): CancelablePromise<AsgardRateSubmissionAsgardRateSubmissionPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/rate_submission",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Download Rater Workbook
 * @param data The data for the request.
 * @param data.reportId
 * @param data.batchId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadRaterWorkbookRaterDownloadReportIdBatchIdGet = (
  data: DownloadRaterWorkbookRaterDownloadReportIdBatchIdGetData
): CancelablePromise<DownloadRaterWorkbookRaterDownloadReportIdBatchIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/rater/download/{report_id}/{batch_id}",
    path: {
      report_id: data.reportId,
      batch_id: data.batchId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Rate Components
 * @param data The data for the request.
 * @param data.reportId
 * @param data.batchId
 * @returns RateComponentsResponse Successful Response
 * @throws ApiError
 */
export const getRateComponentsRaterRateComponentsReportIdBatchIdGet = (
  data: GetRateComponentsRaterRateComponentsReportIdBatchIdGetData
): CancelablePromise<GetRateComponentsRaterRateComponentsReportIdBatchIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/rater/rate_components/{report_id}/{batch_id}",
    path: {
      report_id: data.reportId,
      batch_id: data.batchId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Book Summary
 * @param data The data for the request.
 * @param data.lob
 * @returns BookSummaryResponse Successful Response
 * @throws ApiError
 */
export const getBookSummaryAsgardReinsurerViewBookSummaryGet = (
  data: GetBookSummaryAsgardReinsurerViewBookSummaryGetData
): CancelablePromise<GetBookSummaryAsgardReinsurerViewBookSummaryGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/asgard/reinsurer_view/book_summary",
    query: {
      lob: data.lob,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Submission Analytics
 * @returns SubmissionAnalyticsResponse Successful Response
 * @throws ApiError
 */
export const getSubmissionAnalyticsAsgardSubmissionAnalyticsGet =
  (): CancelablePromise<GetSubmissionAnalyticsAsgardSubmissionAnalyticsGetResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/asgard/submission_analytics",
    });
  };

/**
 * Get Location Classifications
 * @param data The data for the request.
 * @param data.requestBody
 * @returns LocationClassificationsResponse Successful Response
 * @throws ApiError
 */
export const getLocationClassificationsLocationClassificationsPost = (
  data: GetLocationClassificationsLocationClassificationsPostData
): CancelablePromise<GetLocationClassificationsLocationClassificationsPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/location_classifications",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Healthcheck
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const healthcheckHealthcheckGet =
  (): CancelablePromise<HealthcheckHealthcheckGetResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/healthcheck",
    });
  };

/**
 * Login
 * @param data The data for the request.
 * @param data.formData
 * @returns LoginResponse Successful Response
 * @throws ApiError
 */
export const loginLoginPost = (
  data: LoginLoginPostData
): CancelablePromise<LoginLoginPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/login",
    formData: data.formData,
    mediaType: "application/x-www-form-urlencoded",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * List Users
 * @returns ListUserResponse Successful Response
 * @throws ApiError
 */
export const listUsersListUsersPost =
  (): CancelablePromise<ListUsersListUsersPostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/list_users",
    });
  };

/**
 * Log Event
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const logEventLogEventPost = (
  data: LogEventLogEventPostData
): CancelablePromise<LogEventLogEventPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/log_event",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Reports Post
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListReportsResponse Successful Response
 * @throws ApiError
 */
export const asgardListReportsPostAsgardListReportsPost = (
  data: AsgardListReportsPostAsgardListReportsPostData
): CancelablePromise<AsgardListReportsPostAsgardListReportsPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/list_reports",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Report
 * @param data The data for the request.
 * @param data.reportId
 * @param data.includeAddresses
 * @returns ReportResponse Successful Response
 * @throws ApiError
 */
export const asgardListReportAsgardListReportReportIdGet = (
  data: AsgardListReportAsgardListReportReportIdGetData
): CancelablePromise<AsgardListReportAsgardListReportReportIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/asgard/list_report/{report_id}",
    path: {
      report_id: data.reportId,
    },
    query: {
      include_addresses: data.includeAddresses,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Google Group Stats
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GoogleGroupStats Successful Response
 * @throws ApiError
 */
export const asgardGoogleGroupStatsAsgardGoogleGroupStatsPost = (
  data: AsgardGoogleGroupStatsAsgardGoogleGroupStatsPostData
): CancelablePromise<AsgardGoogleGroupStatsAsgardGoogleGroupStatsPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/google_group_stats",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Email Threads
 * Fetch full conversation data for all email threads on a report.
 * @param data The data for the request.
 * @param data.reportId
 * @returns EmailThreadsResponse Successful Response
 * @throws ApiError
 */
export const asgardEmailThreadsAsgardEmailThreadsReportIdGet = (
  data: AsgardEmailThreadsAsgardEmailThreadsReportIdGetData
): CancelablePromise<AsgardEmailThreadsAsgardEmailThreadsReportIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/asgard/email_threads/{report_id}",
    path: {
      report_id: data.reportId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Delete Email Thread
 * Remove an email thread from a report and delete its EML files from GCS.
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns DeleteEmailThreadResponse Successful Response
 * @throws ApiError
 */
export const asgardDeleteEmailThreadAsgardDeleteEmailThreadReportIdPost = (
  data: AsgardDeleteEmailThreadAsgardDeleteEmailThreadReportIdPostData
): CancelablePromise<AsgardDeleteEmailThreadAsgardDeleteEmailThreadReportIdPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/delete_email_thread/{report_id}",
    path: {
      report_id: data.reportId,
    },
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Download Thread Attachment
 * Download an attachment from an email thread message via Microsoft Graph.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardDownloadThreadAttachmentAsgardDownloadThreadAttachmentPost =
  (
    data: AsgardDownloadThreadAttachmentAsgardDownloadThreadAttachmentPostData
  ): CancelablePromise<AsgardDownloadThreadAttachmentAsgardDownloadThreadAttachmentPostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/asgard/download_thread_attachment",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Asgard Generate Underwriting Pdf
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardGenerateUnderwritingPdfAsgardGenerateUnderwritingPdfPost = (
  data: AsgardGenerateUnderwritingPdfAsgardGenerateUnderwritingPdfPostData
): CancelablePromise<AsgardGenerateUnderwritingPdfAsgardGenerateUnderwritingPdfPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/generate_underwriting_pdf",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Quote Indication Preflight
 * Compute the fields shown in the quote indication modal (and used in the
 * drafted email) from server-side data. Keeps the frontend and the drafted
 * email from drifting apart.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns QuoteIndicationPreflight Successful Response
 * @throws ApiError
 */
export const asgardQuoteIndicationPreflightAsgardQuoteIndicationPreflightPost =
  (
    data: AsgardQuoteIndicationPreflightAsgardQuoteIndicationPreflightPostData
  ): CancelablePromise<AsgardQuoteIndicationPreflightAsgardQuoteIndicationPreflightPostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/asgard/quote_indication_preflight",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Asgard Generate Quote Indication Draft
 * Create an Outlook draft with the quote indication
 * @param data The data for the request.
 * @param data.requestBody
 * @returns DraftResponse Successful Response
 * @throws ApiError
 */
export const asgardGenerateQuoteIndicationDraftAsgardGenerateQuoteIndicationDraftPost =
  (
    data: AsgardGenerateQuoteIndicationDraftAsgardGenerateQuoteIndicationDraftPostData
  ): CancelablePromise<AsgardGenerateQuoteIndicationDraftAsgardGenerateQuoteIndicationDraftPostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/asgard/generate_quote_indication_draft",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Asgard Download Loss Run
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardDownloadLossRunAsgardDownloadLossRunPost = (
  data: AsgardDownloadLossRunAsgardDownloadLossRunPostData
): CancelablePromise<AsgardDownloadLossRunAsgardDownloadLossRunPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/download_loss_run",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Update Report
 * @param data The data for the request.
 * @param data.requestBody
 * @returns UpdateReportResponse Successful Response
 * @throws ApiError
 */
export const asgardUpdateReportAsgardUpdateReportPost = (
  data: AsgardUpdateReportAsgardUpdateReportPostData
): CancelablePromise<AsgardUpdateReportAsgardUpdateReportPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/update_report",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Add Manual Address
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AddManualAddressResponse Successful Response
 * @throws ApiError
 */
export const asgardAddManualAddressAsgardAddManualAddressPost = (
  data: AsgardAddManualAddressAsgardAddManualAddressPostData
): CancelablePromise<AsgardAddManualAddressAsgardAddManualAddressPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/add_manual_address",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Batch Comments
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BatchCommentsResponse Successful Response
 * @throws ApiError
 */
export const asgardBatchCommentsAsgardCommentsPost = (
  data: AsgardBatchCommentsAsgardCommentsPostData
): CancelablePromise<AsgardBatchCommentsAsgardCommentsPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/comments",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Add Comment
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AddCommentResponse Successful Response
 * @throws ApiError
 */
export const asgardAddCommentAsgardAddCommentPost = (
  data: AsgardAddCommentAsgardAddCommentPostData
): CancelablePromise<AsgardAddCommentAsgardAddCommentPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/add_comment",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Delete Comment
 * @param data The data for the request.
 * @param data.requestBody
 * @returns DeleteCommentResponse Successful Response
 * @throws ApiError
 */
export const asgardDeleteCommentAsgardDeleteCommentPost = (
  data: AsgardDeleteCommentAsgardDeleteCommentPostData
): CancelablePromise<AsgardDeleteCommentAsgardDeleteCommentPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/delete_comment",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Edit Comment
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EditCommentResponse Successful Response
 * @throws ApiError
 */
export const asgardEditCommentAsgardEditCommentPost = (
  data: AsgardEditCommentAsgardEditCommentPostData
): CancelablePromise<AsgardEditCommentAsgardEditCommentPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/edit_comment",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Delete Report
 * @param data The data for the request.
 * @param data.requestBody
 * @returns DeleteReportResponse Successful Response
 * @throws ApiError
 */
export const asgardDeleteReportAsgardDeleteReportPost = (
  data: AsgardDeleteReportAsgardDeleteReportPostData
): CancelablePromise<AsgardDeleteReportAsgardDeleteReportPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/delete_report",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Update Address
 * @param data The data for the request.
 * @param data.requestBody
 * @returns UpdateAddressResponse Successful Response
 * @throws ApiError
 */
export const asgardUpdateAddressAsgardUpdateAddressPost = (
  data: AsgardUpdateAddressAsgardUpdateAddressPostData
): CancelablePromise<AsgardUpdateAddressAsgardUpdateAddressPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/update_address",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Additional Files
 * @param data The data for the request.
 * @param data.reportId
 * @returns ListAdditionalFilesResponse Successful Response
 * @throws ApiError
 */
export const asgardListAdditionalFilesAsgardListAdditionalFilesReportIdPost = (
  data: AsgardListAdditionalFilesAsgardListAdditionalFilesReportIdPostData
): CancelablePromise<AsgardListAdditionalFilesAsgardListAdditionalFilesReportIdPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/list_additional_files/{report_id}",
    path: {
      report_id: data.reportId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Delete Additional Files
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns DeleteAdditionalFilesResponse Successful Response
 * @throws ApiError
 */
export const asgardDeleteAdditionalFilesAsgardDeleteAdditionalFilesReportIdPost =
  (
    data: AsgardDeleteAdditionalFilesAsgardDeleteAdditionalFilesReportIdPostData
  ): CancelablePromise<AsgardDeleteAdditionalFilesAsgardDeleteAdditionalFilesReportIdPostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/asgard/delete_additional_files/{report_id}",
      path: {
        report_id: data.reportId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Asgard Delete Attachment
 * Remove a user-uploaded attachment from a report.
 *
 * Moves the attachment's GCS blob into a ``deleted_attachments/`` folder and
 * drops its entry from ``attachment_info`` — the file no longer appears on the
 * report or gets reprocessed, but the blob is retained for recovery.
 * Attachments that came from the original email cannot be deleted.
 *
 * Removing an attachment reprocesses just the components it fed (the same
 * scoping used when one is added or reclassified), so the report doesn't keep
 * stale state from the deleted file.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AttachmentInfo Successful Response
 * @throws ApiError
 */
export const asgardDeleteAttachmentAsgardDeleteAttachmentPost = (
  data: AsgardDeleteAttachmentAsgardDeleteAttachmentPostData
): CancelablePromise<AsgardDeleteAttachmentAsgardDeleteAttachmentPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/delete_attachment",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Test Python Function
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns TestPythonFunctionResponse Successful Response
 * @throws ApiError
 */
export const asgardTestPythonFunctionAsgardTestPythonFunctionReportIdPost = (
  data: AsgardTestPythonFunctionAsgardTestPythonFunctionReportIdPostData
): CancelablePromise<AsgardTestPythonFunctionAsgardTestPythonFunctionReportIdPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/test_python_function/{report_id}",
    path: {
      report_id: data.reportId,
    },
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Upload Additional File
 * @param data The data for the request.
 * @param data.reportId
 * @param data.formData
 * @param data.classificationForAllFiles
 * @param data.sourceForAllFiles
 * @returns UploadAdditionalFilesResponse Successful Response
 * @throws ApiError
 */
export const asgardUploadAdditionalFileAsgardUploadAdditionalFilesPost = (
  data: AsgardUploadAdditionalFileAsgardUploadAdditionalFilesPostData
): CancelablePromise<AsgardUploadAdditionalFileAsgardUploadAdditionalFilesPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/upload_additional_files",
    query: {
      report_id: data.reportId,
      classification_for_all_files: data.classificationForAllFiles,
      source_for_all_files: data.sourceForAllFiles,
    },
    formData: data.formData,
    mediaType: "multipart/form-data",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Upload Emls
 * @param data The data for the request.
 * @param data.policyNumber
 * @param data.formData
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardUploadEmlsAsgardUploadEmlsPost = (
  data: AsgardUploadEmlsAsgardUploadEmlsPostData
): CancelablePromise<AsgardUploadEmlsAsgardUploadEmlsPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/upload_emls",
    query: {
      policy_number: data.policyNumber,
    },
    formData: data.formData,
    mediaType: "multipart/form-data",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Upload Email Thread
 * @param data The data for the request.
 * @param data.reportId
 * @param data.formData
 * @returns UploadEmailThreadResponse Successful Response
 * @throws ApiError
 */
export const asgardUploadEmailThreadAsgardUploadEmailThreadPost = (
  data: AsgardUploadEmailThreadAsgardUploadEmailThreadPostData
): CancelablePromise<AsgardUploadEmailThreadAsgardUploadEmailThreadPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/upload_email_thread",
    query: {
      report_id: data.reportId,
    },
    formData: data.formData,
    mediaType: "multipart/form-data",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Download Additional File
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardDownloadAdditionalFileAsgardDownloadAdditionalFilePost = (
  data: AsgardDownloadAdditionalFileAsgardDownloadAdditionalFilePostData
): CancelablePromise<AsgardDownloadAdditionalFileAsgardDownloadAdditionalFilePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/download_additional_file",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Generate Bulk Edit
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BulkEditResponse Successful Response
 * @throws ApiError
 */
export const generateBulkEditAsgardGenerateBulkEditPost = (
  data: GenerateBulkEditAsgardGenerateBulkEditPostData
): CancelablePromise<GenerateBulkEditAsgardGenerateBulkEditPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/generate_bulk_edit",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Download Report File
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadReportFileAsgardDownloadReportFilePost = (
  data: DownloadReportFileAsgardDownloadReportFilePostData
): CancelablePromise<DownloadReportFileAsgardDownloadReportFilePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/download_report_file",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Dev Dump Coroutines
 * @returns string Successful Response
 * @throws ApiError
 */
export const devDumpCoroutinesDevDumpCoroutinesPost =
  (): CancelablePromise<DevDumpCoroutinesDevDumpCoroutinesPostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/dev/dump_coroutines",
    });
  };

/**
 * Csp Report
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const cspReportCspReportPost =
  (): CancelablePromise<CspReportCspReportPostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/csp-report",
    });
  };

/**
 * Asgard List Saved Filters
 * @returns ListSavedFiltersResponse Successful Response
 * @throws ApiError
 */
export const asgardListSavedFiltersAsgardListSavedFiltersPost =
  (): CancelablePromise<AsgardListSavedFiltersAsgardListSavedFiltersPostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/asgard/list_saved_filters",
    });
  };

/**
 * Asgard Delete Saved Filter
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListSavedFiltersResponse Successful Response
 * @throws ApiError
 */
export const asgardDeleteSavedFilterAsgardDeleteSavedFilterPost = (
  data: AsgardDeleteSavedFilterAsgardDeleteSavedFilterPostData
): CancelablePromise<AsgardDeleteSavedFilterAsgardDeleteSavedFilterPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/delete_saved_filter",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Update Saved Filter
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListSavedFiltersResponse Successful Response
 * @throws ApiError
 */
export const asgardUpdateSavedFilterAsgardUpdateSavedFilterPost = (
  data: AsgardUpdateSavedFilterAsgardUpdateSavedFilterPostData
): CancelablePromise<AsgardUpdateSavedFilterAsgardUpdateSavedFilterPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/update_saved_filter",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Add Saved Filter
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListSavedFiltersResponse Successful Response
 * @throws ApiError
 */
export const asgardAddSavedFilterAsgardAddSavedFilterPost = (
  data: AsgardAddSavedFilterAsgardAddSavedFilterPostData
): CancelablePromise<AsgardAddSavedFilterAsgardAddSavedFilterPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/add_saved_filter",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Load Addresses For Map
 * @param data The data for the request.
 * @param data.requestBody
 * @returns LoadAddressesForMapResponse Successful Response
 * @throws ApiError
 */
export const asgardLoadAddressesForMapAsgardLoadAddressesForMapPost = (
  data: AsgardLoadAddressesForMapAsgardLoadAddressesForMapPostData
): CancelablePromise<AsgardLoadAddressesForMapAsgardLoadAddressesForMapPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/load_addresses_for_map",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Load Addresses
 * @param data The data for the request.
 * @param data.reportId
 * @param data.sovId
 * @returns AddressList Successful Response
 * @throws ApiError
 */
export const asgardLoadAddressesAsgardLoadAddressesReportIdSovIdGet = (
  data: AsgardLoadAddressesAsgardLoadAddressesReportIdSovIdGetData
): CancelablePromise<AsgardLoadAddressesAsgardLoadAddressesReportIdSovIdGetResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/asgard/load_addresses/{report_id}/{sov_id}",
    path: {
      report_id: data.reportId,
      sov_id: data.sovId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Eml Preview
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EmlPreviewResponse Successful Response
 * @throws ApiError
 */
export const asgardEmlPreviewAsgardEmlPreviewPost = (
  data: AsgardEmlPreviewAsgardEmlPreviewPostData
): CancelablePromise<AsgardEmlPreviewAsgardEmlPreviewPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/eml_preview",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Download Report History
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardDownloadReportHistoryAsgardDownloadReportHistoryPost = (
  data: AsgardDownloadReportHistoryAsgardDownloadReportHistoryPostData
): CancelablePromise<AsgardDownloadReportHistoryAsgardDownloadReportHistoryPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/download_report_history",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Updating Reports
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListUpdatingReportsResponse Successful Response
 * @throws ApiError
 */
export const asgardListUpdatingReportsAsgardListUpdatingReportsPost = (
  data: AsgardListUpdatingReportsAsgardListUpdatingReportsPostData
): CancelablePromise<AsgardListUpdatingReportsAsgardListUpdatingReportsPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/list_updating_reports",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Report Jobs
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListReportJobsResponse Successful Response
 * @throws ApiError
 */
export const asgardListReportJobsAsgardListReportJobsPost = (
  data: AsgardListReportJobsAsgardListReportJobsPostData
): CancelablePromise<AsgardListReportJobsAsgardListReportJobsPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/list_report_jobs",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Cancel Job
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CancelJobResponse Successful Response
 * @throws ApiError
 */
export const asgardCancelJobAsgardCancelJobPost = (
  data: AsgardCancelJobAsgardCancelJobPostData
): CancelablePromise<AsgardCancelJobAsgardCancelJobPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/cancel_job",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Templates
 * @returns ListTemplatesResponse Successful Response
 * @throws ApiError
 */
export const asgardListTemplatesAsgardListTemplatesPost =
  (): CancelablePromise<AsgardListTemplatesAsgardListTemplatesPostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/asgard/list_templates",
    });
  };

/**
 * Asgard Delete Template
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListTemplatesResponse Successful Response
 * @throws ApiError
 */
export const asgardDeleteTemplateAsgardDeleteTemplatePost = (
  data: AsgardDeleteTemplateAsgardDeleteTemplatePostData
): CancelablePromise<AsgardDeleteTemplateAsgardDeleteTemplatePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/delete_template",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Update Template
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListTemplatesResponse Successful Response
 * @throws ApiError
 */
export const asgardUpdateTemplateAsgardUpdateTemplatePost = (
  data: AsgardUpdateTemplateAsgardUpdateTemplatePostData
): CancelablePromise<AsgardUpdateTemplateAsgardUpdateTemplatePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/update_template",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Create Template
 * @param data The data for the request.
 * @param data.useCase
 * @param data.formData
 * @returns ListTemplatesResponse Successful Response
 * @throws ApiError
 */
export const asgardCreateTemplateAsgardCreateTemplatePost = (
  data: AsgardCreateTemplateAsgardCreateTemplatePostData
): CancelablePromise<AsgardCreateTemplateAsgardCreateTemplatePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/create_template",
    query: {
      use_case: data.useCase,
    },
    formData: data.formData,
    mediaType: "multipart/form-data",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Download Template
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardDownloadTemplateAsgardDownloadTemplatePost = (
  data: AsgardDownloadTemplateAsgardDownloadTemplatePostData
): CancelablePromise<AsgardDownloadTemplateAsgardDownloadTemplatePostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/download_template",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Generate Policy Numbers
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GeneratedPolicyNumbers Successful Response
 * @throws ApiError
 */
export const asgardGeneratePolicyNumbersAsgardGeneratePolicyNumbersPost = (
  data: AsgardGeneratePolicyNumbersAsgardGeneratePolicyNumbersPostData
): CancelablePromise<AsgardGeneratePolicyNumbersAsgardGeneratePolicyNumbersPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/generate_policy_numbers",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Generate Policy Fly Application
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GeneratePolicyFlyApplicationResponse Successful Response
 * @throws ApiError
 */
export const asgardGeneratePolicyFlyApplicationAsgardGeneratePolicyFlyApplicationPost =
  (
    data: AsgardGeneratePolicyFlyApplicationAsgardGeneratePolicyFlyApplicationPostData
  ): CancelablePromise<AsgardGeneratePolicyFlyApplicationAsgardGeneratePolicyFlyApplicationPostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/asgard/generate_policy_fly_application",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Asgard Clearance Email Recipients
 * Return the list of recipients that would receive a clearance email.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ClearanceEmailRecipientsResponse Successful Response
 * @throws ApiError
 */
export const asgardClearanceEmailRecipientsAsgardClearanceEmailRecipientsPost =
  (
    data: AsgardClearanceEmailRecipientsAsgardClearanceEmailRecipientsPostData
  ): CancelablePromise<AsgardClearanceEmailRecipientsAsgardClearanceEmailRecipientsPostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/asgard/clearance_email_recipients",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        422: "Validation Error",
      },
    });
  };

/**
 * Asgard Send Clearance Email
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GeneratedPolicyNumbers Successful Response
 * @throws ApiError
 */
export const asgardSendClearanceEmailAsgardSendClearanceEmailPost = (
  data: AsgardSendClearanceEmailAsgardSendClearanceEmailPostData
): CancelablePromise<AsgardSendClearanceEmailAsgardSendClearanceEmailPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/send_clearance_email",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Sync Metabase
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const syncMetabaseAsgardSyncMetabasePost =
  (): CancelablePromise<SyncMetabaseAsgardSyncMetabasePostResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/asgard/sync_metabase",
    });
  };
